import { parse } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import { useCallback } from 'react';
import { now } from '../../common/util/now';
import { FormState } from '../FormState/FormState';

export const statelessClientDateFunction = (
  format: string,
  practiceTimeZone?: string,
  dateStringToFormat?: string,
  showApptTimeInPatientTimezone?: boolean,
) => {
  if (!dateStringToFormat || !practiceTimeZone) {
    return { date: undefined, isClientTime: false };
  }

  if (showApptTimeInPatientTimezone) {
    return {
      date: zonedTimeToUtc(dateStringToFormat, practiceTimeZone, {
        timeZone: practiceTimeZone,
      }),
      isClientTime: true,
    };
  } else {
    return {
      date: parse(dateStringToFormat, format, now()),
      isClientTime: false,
    };
  }
};

export const useClientDateFunction = (state: FormState) =>
  useCallback(
    (dateString: string, format: string) => {
      const practiceForFormat = state.appointment.practice;
      const dateStringToFormat = dateString;

      return statelessClientDateFunction(
        format,
        practiceForFormat?.timezone,
        dateStringToFormat,
        practiceForFormat?.showApptTimeInPatientTimezone,
      );
    },
    [state.appointment.practice],
  );
